import React, { useState, useEffect } from 'react';
import { ExpandableTile } from 'carbon-components-react';

import TableComponent from "common/TableComponent";
import * as DashboardConstants from '.././DashboardConstants';

export default function AutomataNameListView(props) {
    let rows = props.rows;
    const [table, setTable] = useState(false);
    const [total, setTotal] = useState(0);
    // const content = <div className="row col-lg-12 col-md-12">
    //     <div className="col-lg-9">{props.component} -> {props.competency} -> {props.serviceProcessName}</div>
    //     <span className="col-lg-2">{props.selectedKpi}</span>
    // </div>;
    //const value = <div className='lens-value'>{props.selectedKpi}</div>

    useEffect(() => {
        prepareOverallValue()
    }, [props.rows]);

    const content = <div className='level'>
        {props.client ? <div>{props.client} </div> : ''}
        {props.competency ? <div>/ {props.competency} </div> : ''}
        {props.component ? <div>/ {props.component}</div> : ''}
        {props.serviceProcessName ? <div> / {props.serviceProcessName}</div> : ''}
    </div>

    function handleClick() {
        setTable(!table);
    }
    function prepareOverallValue() {
        console.log(rows);
        let sum = 0, total = props.rows.length, avg = 0;
        if (props.selectedKpi === DashboardConstants.ROI) {
            props.rows.map((rowItem) => {
                sum = parseFloat(sum) + parseFloat(rowItem.value);
            })
            console.log(sum);
            setTotal(`${props.selectedKpi} : ${sum.toFixed(2)}`);
        }
        else {
            props.rows.map((rowItem) => {
                sum = parseFloat(sum) + parseFloat(rowItem.value);
            });
            avg = sum / total;
            console.log(avg);
            setTotal(isNaN(avg) ? 0 : `${props.selectedKpi} : ${avg.toFixed(2)}`);
        }
    }
    return (
        <div>
            <ExpandableTile value="service process name" handleClick={handleClick}>
                <div className="total-value">
                    <div>{content}</div>
                    <div className="total">{total}</div>
                </div>
            </ExpandableTile>
            {table === true && <TableComponent rows={props.rows} headers={props.headers} title="Automata Name" />}
        </div>
    )
}